<div class="align-right">
  <button mat-button color="primary" (click)="addUser()">
    <mat-icon>add_circle_outline</mat-icon>
    <span> add </span>
  </button>
  <button mat-button color="primary" (click)="print()">
    <mat-icon>print</mat-icon>
    <span> print </span>
  </button>
</div>
<div class="table-container">
  <table mat-table [dataSource]="users" matSort>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.countries.last-name" |translate}}</th>
      <td mat-cell *matCellDef="let user">{{user.name}}</td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.countries.first-name" |translate}}</th>
      <td mat-cell *matCellDef="let user">{{user.firstName}}</td>
    </ng-container>

    <ng-container matColumnDef="weeeSystem.description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.weee-system.weee-system" |translate}}</th>
      <td mat-cell *matCellDef="let user">{{user.weeeSystem !== null ? user.weeeSystem.description : ''}}</td>
    </ng-container>

    <ng-container matColumnDef="role.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{"admin.weee-system.role" |translate}}</th>
      <td mat-cell *matCellDef="let user">{{user.role !== null ? user.role.name : ''}}</td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let user">
        <mat-icon (click)="editUser(user)" color="primary"
                  matTooltip="Edit" matTooltipPosition="above">edit
        </mat-icon>
        <mat-icon *ngIf="user.status === 'ACTIVE'" color="primary"
                  matTooltip="Disable" matTooltipPosition="above"
                  (click)="updateUser(user, false)">check_circle
        </mat-icon>
        <mat-icon *ngIf="user.status === 'INACTIVE'"
                  color="primary" matTooltip="Enable" matTooltipPosition="above"
                  (click)="updateUser(user, false)">radio_button_unchecked
        </mat-icon>
        <mat-icon *ngIf="user.status === 'INACTIVE'"
                  color="primary" matTooltip="Delete" matTooltipPosition="above"
                  (click)="updateUser(user, true)">delete
        </mat-icon>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>
